// A developer's aid for the loading states (4 Nov 2026): on the example data
// only (a developer's machine or a design-review build), ?slow=1500 makes
// every read take about that long, and ?fail=2 makes the first two reads fail,
// so the skeletons, the top line, « Réessayer » and the failed-refresh signs
// can be seen and checked. The live console never goes through this.
const q = (() => { try { return new URLSearchParams(location.search); } catch { return new URLSearchParams(); } })();
const SLOW = Math.min(10_000, Math.max(0, Number(q.get('slow')) || 0));
let fails = Math.max(0, Number(q.get('fail')) || 0);

export function slowed<T extends object>(src: T): T {
  if (!SLOW && !fails) return src;
  return new Proxy(src, {
    get(t, k, r) {
      const v = Reflect.get(t, k, r);
      if (typeof v !== 'function' || k === 'subscribe') return v;
      return (...a: unknown[]) => {
        const out = (v as (...x: unknown[]) => unknown).apply(t, a);
        if (!(out instanceof Promise)) return out;
        const bad = fails > 0 && fails-- > 0;
        const wait = SLOW * (0.6 + Math.random() * 0.8);
        return new Promise((res, rej) => setTimeout(() => (bad ? rej(new Error('Échec simulé (?fail)')) : out.then(res, rej)), wait));
      };
    },
  });
}
